export const drawerWidth = 260;

export const APP_INFO = {
  AppName: 'equipment-action-portal',
  AppDisplayName: 'Equipment Action Portal',
  AppDescription: 'Web App to initiate and manage equipment action requests',
  Scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'ApiGw.account',
    'ApiGw.thrive',
    'ApiGw.appl-user',
    'ApiGw.app-analytics',
    'ApiGw.teammembers',
    'ApiGw.org-management',
    'ApiGw.inv-mgmt',
  ],
  WhatsNewFeatureKey: 31,
};

export const LOGIN_PAGE_INFO = {
  LoginButtonText: 'Login',
};

export const EBS_INSTANCES = [
  { name: 'DEV', instanceID: 'EBSDEV' },
  { name: 'DEV2', instanceID: 'EBSDEV2' },
  { name: 'DEV3', instanceID: 'EBSDEV3' },
  { name: 'DEV4', instanceID: 'EBSDEV4' },
  { name: 'DEV5', instanceID: 'EBSDEV5' },
  { name: 'DEV6', instanceID: 'EBSDEV6' },
];

/**
 * Gets the EBS instance name based on the API URL
 * @returns {string} The EBS instance name (EBSDEV3, EBSQA, or EBSPROD)
 */
export const getInstanceName = () => {
  const apiUrl = window.REACT_APP_API_URL || '';
  if (apiUrl.includes('apidev')) {
    return 'EBSDEV3';
  } else if (apiUrl.includes('apiqa')) {
    return 'EBSQA';
  }
  return 'EBSPROD';
};

export const oktaConfig = {
  issuer: window.REACT_APP_OKTA_ISSUER ?? process.env.REACT_APP_OKTA_ISSUER,
  clientId: window.REACT_APP_OKTA_CLIENTID ?? process.env.REACT_APP_OKTA_CLIENTID,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'ApiGw.account',
    'ApiGw.thrive',
    'ApiGw.appl-user',
    'ApiGw.app-analytics',
    'ApiGw.teammembers',
    'ApiGw.org-management',
    'ApiGw.inv-mgmt',
  ],
  pkce: true,
  disableHttpsCheck: window.OKTA_TESTING_DISABLEHTTPSCHECK || false,
  postLogoutRedirectUri: window.REACT_POST_LOGOUT_URL ?? process.env.REACT_POST_LOGOUT_URL,
};

export const showInstanceSelector = {
  show: true,
};

export const showRequestAccess = {
  show: false,
};

export const showProvideFeedback = {
  show: true,
};
export const autoAssignNext = true; // used in Work Order Edit page to auto assign next wo if desired
export const sendTeamsMessages = true; // can use this to turn off teams messages for testing
